var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment-card-container p-3",
      class: _vm.creditcard ? "has-hover" : ""
    },
    [
      _vm.creditcard
        ? _c("div", { staticClass: "payment-card" }, [
            _c("div", {
              staticClass: "payment-card-logo",
              style: _vm.dynamicStyleLogo
            }),
            _vm._v(" "),
            _c("div", { staticClass: "payment-card-number" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$filters.creditCard(_vm.creditcard.last4).toUpperCase()
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-card-expire-date" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.creditcard.expireDate) +
                  "\n        "
              )
            ])
          ])
        : _c("div", { staticClass: "payment-card template-add-card" }, [
            _c("div", { staticClass: "payment-card-add" }, [
              _c("div", { staticClass: "acenter" }, [
                _vm.validationInProgress
                  ? _c("span", [_vm._v(_vm._s(_vm.validationMessage))])
                  : _c("span", [_vm._v(_vm._s(_vm.placeholder))])
              ])
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }